import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import { ExternalLink } from "components/common";
import EmbeddedOnePasswordApp from "./EmbeddedOnePasswordApp";
const OnePasswordApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("onepassword.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("onepassword.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "onepassword.app.subscription_required",
      components: { externalLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://start.1password.com/sign-up?l=en" }) }
    }
  ))), /* @__PURE__ */ React.createElement(EmbeddedOnePasswordApp, null));
};
export default OnePasswordApp;
